import { render, staticRenderFns } from "./Empty.vue?vue&type=template&id=86ee08c4"
import script from "./Empty.vue?vue&type=script&lang=js"
export * from "./Empty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('86ee08c4')) {
      api.createRecord('86ee08c4', component.options)
    } else {
      api.reload('86ee08c4', component.options)
    }
    module.hot.accept("./Empty.vue?vue&type=template&id=86ee08c4", function () {
      api.rerender('86ee08c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/Empty.vue"
export default component.exports